var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBookmarkWhite = function SvgBookmarkWhite(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Business"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.16683 1.66699H15.8335C16.2937 1.66699 16.6668 2.04009 16.6668 2.50033V18.4531C16.6668 18.6832 16.4802 18.8698 16.2502 18.8698C16.1719 18.8698 16.0952 18.8477 16.0288 18.8061L10.0002 15.0264L3.97149 18.8061C3.77652 18.9283 3.51938 18.8694 3.39714 18.6744C3.35555 18.6081 3.3335 18.5314 3.3335 18.4531V2.50033C3.3335 2.04009 3.7066 1.66699 4.16683 1.66699ZM15.0002 3.33366H5.00016V16.194L10.0002 13.0592L15.0002 16.194V3.33366Z",
    fill: "#424242"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBookmarkWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bookmark-white.55fec7b9.svg";
export { ForwardRef as ReactComponent };